import Alert from 'components/Alert'
import { AddressView } from '../../pages/address/[address]'

type ManageEmptyState = {
  view: AddressView
}

export default function ManageEmptyState({ view }: ManageEmptyState) {
  const nfdState = view.replace('-', ' ')

  return (
    <div className="px-4 sm:px-6 lg:px-8 mt-6">
      <div className="sm:flex sm:items-center">
        <div className="hidden sm:block flex-auto">
          <h1 className="text-xl font-semibold text-gray-900 capitalize">
            {view.replace('-', ' ')}
          </h1>
          <p className="mt-2 text-sm text-gray-700">This account&apos;s NFDs that are {nfdState}</p>
        </div>
      </div>
      <div className="mt-6 flex flex-col">
        <Alert type="info" title={`No NFDs currently ${nfdState}`} />
      </div>
    </div>
  )
}
